// Elegant placeholder shown while the AI-generated asset is missing.
// When the webp lands in public/assets/campus/ the real image takes
// over automatically (img onError fallback in FacilityCard/CampusHero).

import type { LucideIcon } from 'lucide-react'

interface FacilityPlaceholderProps {
  gradient: [string, string]
  icon: LucideIcon
  caption?: string
}

export function FacilityPlaceholder({ gradient, icon: Icon, caption }: FacilityPlaceholderProps) {
  return (
    <div
      className="facility-placeholder"
      style={{
        background: `
          repeating-linear-gradient(45deg, rgba(255,255,255,0.03) 0 6px, transparent 6px 18px),
          linear-gradient(135deg, ${gradient[0]} 0%, ${gradient[1]} 130%)
        `,
        flexDirection: 'column',
        gap: '0.4rem',
      }}
    >
      <Icon size={48} style={{ opacity: 0.25, color: '#fff' }} />
      {caption && (
        <span style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.55)', fontWeight: 600 }}>
          {caption}
        </span>
      )}
    </div>
  )
}
